import script from "./IVRConfigComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./IVRConfigComponent.vue?vue&type=script&setup=true&lang=js"

import "./IVRConfigComponent.vue?vue&type=style&index=0&id=2da34077&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebasezoom\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da34077"]])

export default __exports__